module.exports = __webpack_public_path__ + "./images/6047cbcf12624cc5f7d06c637e699d22.webp";